import React from 'react'
import { TWContentBlockFullWidth } from '../../../TWContentBlockFullWidth/TWContentBlockFullWidth'
import { IconPuzzle } from '../../../icons/IconPuzzle/IconPuzzle'

export function TWAppDownloadPuzzlesBlock() {
    const imgSrc = require('../assets/puzzles-content-block-image.webp')

    return (
        <TWContentBlockFullWidth
            heading={'Sharpen your mind with daily puzzles'}
            subText={
                'Crosswords, Sudoku, Target and Word Search to keep you challenged every day.'
            }
            imgSrc={imgSrc}
            contentPosition={'left'}
            headingIntent={{
                headingIntentStartIndex: 4,
                headingIntentLength: 2,
            }}
            headerIcon={<IconPuzzle />}
            isBottomAligned={true}
        />
    )
}
